import React from 'react';
import ApexLogo from '../ApexLogo';

/**
 * APEX v7.3 — App Header Logo
 *
 * Logo officiel APEX dans le header de l'app.
 * Combine le SVG ApexLogo + le wordmark "APEX" gradient cyan→fuchsia
 * + le sous-titre "Coach de climb".
 *
 * Extracted from App.jsx in v7.3 (refactor wave 1).
 */
export default function AppHeaderLogo() {
  return (
    <div className="flex items-center gap-3">
      <ApexLogo size={40} />
      <div>
        <div className="font-black text-xl leading-none">
          <span className="bg-gradient-to-r from-cyan-400 via-cyan-300 to-fuchsia-400 bg-clip-text text-transparent tracking-widest">
            APEX
          </span>
        </div>
        <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mt-1">
          Coach de climb
        </div>
      </div>
    </div>
  );
}
